import React from "react";

const OPTIONS_STYLE = {
  display: "flex",
  flexWrap: "wrap",
  gap: "16px 24px",
  margin: "8px 0 12px",
};

const OPTION_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
  color: "rgba(255, 255, 255, 0.88)",
  cursor: "pointer",
};

const INPUT_STYLE = {
  accentColor: "#c9a84c",
  width: "16px",
  height: "16px",
  margin: 0,
};

export function InlineRadioGroup({
  name,
  value,
  onChange,
  options,
  disabled = false,
}) {
  return (
    <div style={OPTIONS_STYLE} role="radiogroup">
      {options.map((option) => (
        <label
          key={option.value}
          style={{
            ...OPTION_STYLE,
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
            style={INPUT_STYLE}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
}
